module.exports = __webpack_public_path__ + "static/media/playstore.62954b88.png";